import { render, staticRenderFns } from "./PanelProvisionListAdmin.vue?vue&type=template&id=b4295a7c&scoped=true&"
import script from "./PanelProvisionListAdmin.vue?vue&type=script&lang=js&"
export * from "./PanelProvisionListAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PanelProvisionListAdmin.vue?vue&type=style&index=0&id=b4295a7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4295a7c",
  null
  
)

export default component.exports